import { useQuery } from '@apollo/client/react'
import { useSplitEnabled } from '@buffer-mono/features'

import { graphql } from '~publish/graphql'
import type { ResultOf, VariablesOf } from '~publish/graphql'

import { PostCard_Post } from '~publish/components/PostCard/fragments/PostCard_Post'
import { COLLABORATION_NOTES_SPLIT } from '~publish/components/PostDialogs/PostDetailsContent/useCollaborationNotesPanel'
import { PostUnreadMentionCount } from '~publish/hooks/notes/fragments/PostUnreadMentionCount'
import { PostUnreadNoteCount } from '~publish/hooks/notes/fragments/PostUnreadNoteCount'

export const GetPostForCalendarPostCard = graphql(
  `
    query GetPostForCalendarPostCard(
      $id: PostId!
      $includeNotesSummary: Boolean! = false
    ) {
      post(input: { id: $id }) {
        ...PostCard_Post
        ...PostUnreadNoteCount @include(if: $includeNotesSummary)
        ...PostUnreadMentionCount @include(if: $includeNotesSummary)
      }
    }
  `,
  [PostCard_Post, PostUnreadNoteCount, PostUnreadMentionCount],
)

type UseQueryResponse = ReturnType<
  typeof useQuery<
    ResultOf<typeof GetPostForCalendarPostCard>,
    VariablesOf<typeof GetPostForCalendarPostCard>
  >
>
export const useLoadCalendarPostCard = (
  id: string,
  { skip = false } = {},
): UseQueryResponse => {
  const { isReady, isEnabled } = useSplitEnabled(COLLABORATION_NOTES_SPLIT)
  return useQuery(GetPostForCalendarPostCard, {
    variables: { id, includeNotesSummary: isReady && isEnabled },
    skip,
    errorPolicy: 'all',
  })
}
